// Old WebView engines (pre-2020) hitting the public site lack String.prototype.replaceAll,
// which PrimeVue's theme engine (@primeuix/styled) relies on at component mount.
// Sentry: VUE-FRONTEND-CV, VUE-FRONTEND-5W
// Typed via a local cast because tsconfig lib predates ES2021 (app code should not use replaceAll).
type ReplaceValue = string | ((substring: string, ...args: unknown[]) => string)

const stringProto = String.prototype as {
  replaceAll?: (searchValue: string | RegExp, replaceValue: ReplaceValue) => string
}

if (!stringProto.replaceAll) {
  Object.defineProperty(String.prototype, 'replaceAll', {
    enumerable: false,
    writable: true,
    configurable: true,
    value: function (this: string, searchValue: string | RegExp, replaceValue: ReplaceValue) {
      if (searchValue instanceof RegExp) {
        return this.replace(searchValue, replaceValue as string)
      }
      const escaped = String(searchValue).replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
      return this.replace(new RegExp(escaped, 'g'), replaceValue as string)
    },
  })
}

export {}
